import BasicInitContainer from "../../../../../Components/Forms&Table/Tables/DataTables/BasicInit/BasicInitContainer";

const BasicInit = () => {
  return <BasicInitContainer />;
};

export default BasicInit;
